/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { EvalRunListResponseDto } from '../models/EvalRunListResponseDto';
import type { EvalRunView } from '../models/EvalRunView';

export class DiscoveryEvaluationRunsService {
  constructor(public readonly httpRequest: BaseHttpRequest) {}
  /**
   * List Eval Runs
   * Scan the runs dir for `run_*.json` and summarize each `RunKey`.
   * @returns EvalRunListResponseDto Successful Response
   * @throws ApiError
   */
  public listEvalRunsInternalDiscoveryEvaluationRunsGet(): CancelablePromise<EvalRunListResponseDto> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/runs',
    });
  }
  /**
   * Get Eval Run
   * Load one stored artifact and reshape it via `to_view_payload` —
   * no recomputation beyond the reshape itself.
   * @param runId
   * @returns EvalRunView Successful Response
   * @throws ApiError
   */
  public getEvalRunInternalDiscoveryEvaluationRunsRunIdGet(
    runId: string
  ): CancelablePromise<EvalRunView> {
    return this.httpRequest.request({
      method: 'GET',
      url: '/internal/discovery/evaluation/runs/{run_id}',
      path: {
        run_id: runId,
      },
      errors: {
        422: `Validation Error`,
      },
    });
  }
}
